import {AbstractApiService} from "./AbstractApiService";
import {API_SERVICE_URL, ATLASSIAN_PLUGIN_KEY, isRunningInDevMode} from "navigation-common/firebase-config";

class AppLicenceService extends AbstractApiService {
    async hasValidLicence(): Promise<boolean> {
        if (isRunningInDevMode()) {
            return true;
        }

        try {
            const response = await this.client.get(API_SERVICE_URL + "/hasValidLicense", this.buildJWTAuthAxiosConfig());
            return response.data as boolean;
        } catch (e) {
            console.log("Error while checking licence validity: " + e);
        }

        return true;
    }

    async getAppVersion(): Promise<string> {
        // @ts-ignore
        try {
            const data = await AP.request({
                url: `/rest/atlassian-connect/1/addons/${ATLASSIAN_PLUGIN_KEY}`,
                type: 'GET',
            });
            return JSON.parse(data.body)?.version;
        } catch (e) {
            console.log("Error while getting app version: " + e);
        }

        return Promise.resolve("unknown");
    }
}

export const appLicenceService = new AppLicenceService();
